// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"scrollbar_scrollbar__uEd_s","inner":"scrollbar_inner__GHrz8"};